<template>
    <div>
        <div v-if="data && data.length > 0">
            <div class="row text-h6"><p>My Orders</p></div>
            <q-card class="bg-transparent">
                <div class="row full-width">
                    <div class="col">
                        <q-table dense
                                 wrap-cells
                                 color="primary"
                                 card-container-class="q-col-gutter-md"
                                 :grid="screenSize.lt.md"
                                 :loading="getOrderCustomerPending"
                                 :hide-no-data="getOrderCustomerPending"
                                 :data="data" :columns="columns"
                                 :pagination.sync="pagination" row-key="orderID"
                                 :hide-bottom="(data) ? data.length < pagination.rowsPerPage : false">
                            <template v-slot:header="props">
                                <q-tr :props="props">
                                    <q-th v-for="col in props.cols"
                                          :key="col.name"
                                          :props="props">
                                        {{ col.label }}
                                    </q-th>
                                </q-tr>
                            </template>
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td v-for="col in props.cols"
                                          :key="col.name"
                                          :props="props">
                                        <div v-if="col.name=='orderId'">
                                            <router-link :to="{ name: '/myaccount/orders/order-details', params: { id: col.value }}"
                                                         class="text-primary">{{ col.value }}</router-link>
                                        </div>
                                        <div v-else-if="col.name=='status'">
                                            <q-badge transparent :color="getOrderStatusColor(col.value)">
                                                {{ getOrderStatus(col.value) }}
                                            </q-badge>
                                        </div>
                                        <div v-else-if="col.name=='actions'">
                                            <q-btn outline size="sm" label="Details" color="primary" @click="$router.push({ name: '/myaccount/orders/order-details', params: { id: col.value }})" />
                                        </div>
                                        <div v-else>
                                            {{ col.value }}
                                        </div>
                                    </q-td>
                                </q-tr>
                            </template>
                            <template v-slot:item="props">
                                <div class="col-xs-12 col-sm-6">
                                    <q-card class="full-height">
                                        <q-card-section class="full-height">
                                            <q-item class="row full-height q-pa-none">
                                                <q-item-section class="column justify-between">
                                                    <div>
                                                        <q-badge transparent :color="getOrderStatusColor(props.row['status'])" class="float-right">
                                                            {{ getOrderStatus(props.row['status']) }}
                                                        </q-badge>
                                                        <div class="row">
                                                            <div class="col">
                                                                <q-field dense label="Order ID" stack-label borderless
                                                                         hide-bottom-space
                                                                         label-color="accent"
                                                                         class="full-width">
                                                                    <template v-slot:control>
                                                                        <span class="text-weight-medium">{{ props.row['orderID']}}</span>
                                                                    </template>
                                                                </q-field>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <q-field dense label="Date" stack-label borderless
                                                                         hide-bottom-space
                                                                         label-color="accent"
                                                                         class="text-caption full-width">
                                                                    <template v-slot:control>
                                                                        <span>{{ props.row['orderDate'] | date }}</span>
                                                                    </template>
                                                                </q-field>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <q-field dense label="Sub Total" stack-label borderless
                                                                         hide-bottom-space
                                                                         label-color="accent"
                                                                         class="text-caption full-width">
                                                                    <template v-slot:control>
                                                                        <span>{{ props.row['subTotal'] | currency }}</span>
                                                                    </template>
                                                                </q-field>
                                                            </div>
                                                            <div class="col">
                                                                <q-field dense label="Tax" stack-label borderless
                                                                         hide-bottom-space
                                                                         label-color="accent"
                                                                         class="text-caption full-width">
                                                                    <template v-slot:control>
                                                                        <span>{{ props.row['tax'] | currency }}</span>
                                                                    </template>
                                                                </q-field>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <q-field dense label="Total" stack-label borderless
                                                                         hide-bottom-space
                                                                         label-color="accent"
                                                                         class="text-caption full-width">
                                                                    <template v-slot:control>
                                                                        <span>{{ props.row['total'] | currency }}</span>
                                                                    </template>
                                                                </q-field>
                                                            </div>
                                                            <div class="col">
                                                                <q-field dense label="Currency" stack-label borderless
                                                                         hide-bottom-space
                                                                         label-color="accent"
                                                                         class="text-caption full-width">
                                                                    <template v-slot:control>
                                                                        <span>{{ props.row['currency'] ? 'USD' : 'CAD' }}</span>
                                                                    </template>
                                                                </q-field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row justify-center q-mt-sm">
                                                        <q-btn outline size="sm" class="full-width" label="Order Details" color="primary" @click="$router.push({ name: '/myaccount/orders/order-details', params: { id: props.row['orderID'] }})" />
                                                    </div>
                                                </q-item-section>
                                            </q-item>
                                        </q-card-section>
                                    </q-card>
                                </div>
                            </template>
                        </q-table>
                    </div>
                </div>
            </q-card>
        </div>
        <div v-else style="padding-top: 0">

            <q-banner v-if="data" rounded class="bg-grey-3" style="border-left: 4px solid #16466f">
                <template v-slot:avatar>
                    <q-icon name="mdi-information-outline" color="primary" />
                </template>
                <div class="text-subtitle1 text-weight-light">You currently don't have any orders.</div>
                <template v-slot:action>
                    <q-btn color="primary" flat label="Let's go shopping" class="q-my-sm" to="/store" />
                </template>
            </q-banner>
        </div>

        <div v-if="getOrderCustomerPending" class="text-center">
            <q-spinner color="primary"
                       :thickness="2"
                       size="3em" />
        </div>

    </div>
</template>
<script>
    import { date } from 'quasar'
    import { mapState } from 'vuex'

    export default {
        name: 'account-orders',
        props: {
        },
        data() {
            return {
                pagination: {
                    sortBy: 'desc',
                    descending: false,
                    page: 1,
                    rowsPerPage: 0
                    // rowsNumber: xx if getting data from a server
                },
                columns: [
                    { name: 'orderId', label: 'Order ID', align: 'left', field: 'orderID', sortable: true },
                    { name: 'date', label: 'Date', align: 'right', field: 'orderDate', sortable: true, format: (val, row) => (val) ? `${date.formatDate(new Date(val), 'YYYY/MM/DD')}` : '' },
                    { name: 'subTotal', label: 'Sub Total', align: 'right', field: 'subTotal', sortable: true, format: (val, row) => val !== null ? `$${val.toFixed(2)}` : '' },
                    { name: 'tax', label: 'Tax', align: 'right', field: 'tax', sortable: true, format: (val, row) => val !== null ? `$${val.toFixed(2)}` : '' },
                    { name: 'total', label: 'Total', align: 'right', field: 'total', sortable: true, format: (val, row) => val !== null ? `$${val.toFixed(2)}` : '' },
                    { name: 'currency', label: 'Currency', align: 'left', field: 'currency', sortable: true, format: (val, row) => val == 1 ? 'CAD' : 'USD' },
                    { name: 'status', label: 'Status', align: 'left', field: 'status', sortable: true },
                    { name: 'actions', label: '', field: 'orderID', align: 'right' },
                ],
            }
        },
        methods: {
            getOrders() {
                this.$store.dispatch('getOrderCustomer', this.user.id).then(() => { })
            },
        },
        computed: {
            ...mapState([
                'getOrderCustomerPending',
                'getOrderCustomerData',
            ]),
            user() { return this.$store.getters.authUser },
            data() {
                // Filter will ensure that only orders with a status of Complete, Failed, Declined or Processing are shown.
                // Orders with a status of Created, In Progress or Cancelled will not be shown to the user.
                if (this.getOrderCustomerData)
                    return this.getOrderCustomerData?.filter(d => d.status >= 3)
                return null
            },
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            this.getOrders()
        }

    }
</script>
<style lang="scss" scoped>

    .q-table--dense .q-table td {
        padding: 6px 8px;
    }

    .q-table--dense .q-table th {
        padding: 12px 8px;
    }

    .q-table--dense .q-table th:first-child, .q-table--dense .q-table td:first-child {
        padding-left: 16px;
    }

    .q-table--dense .q-table th:last-child, .q-table--dense .q-table td:last-child {
        padding-right: 16px;
    }

</style>
